import { render, staticRenderFns } from "./harmonyprivacy.vue?vue&type=template&id=44078d7b&scoped=true&"
import script from "./harmonyprivacy.vue?vue&type=script&lang=ts&"
export * from "./harmonyprivacy.vue?vue&type=script&lang=ts&"
import style0 from "./harmonyprivacy.vue?vue&type=style&index=0&id=44078d7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44078d7b",
  null
  
)

export default component.exports